import React from 'react'
import { Link } from 'react-router-dom'

const Client = () => {
  return (
    <section className="clients-section alternate2">
  <div className="auto-container">
    <div className="row">
      {/* Title Column */}
      <div className="title-column col-xl-3 col-lg-4 col-md-12">
        <div className="sec-title">
          <span className="sub-title">Clients</span>
          <h2>
            Our Official <br />
            Sponsors
          </h2>
          <div className="divider" />
          <div className="text">
            We have dedicated tracks for every industry Whether you want to hire
            tech’s top talent.
          </div>
          <Link  to="buy-ticket.html" className="theme-btn btn-style-one mt-4">
            <span className="btn-title">Donate</span>
          </Link> 
        </div>
      </div>
      {/* Title Column */}
      <div className="title-column col-xl-9 col-lg-8 col-md-12">
        <div className="sponsors-outer">
          <div className="row">
            {/* Client Block */}
            <div className="client-block col-lg-4 col-md-6 col-sm-12 wow fadeInRight">
              <figure className="image-box">
                <Link  to="#">
                  <img src="/assets/images/clients/1.jpg" alt="" />
                </Link> 
              </figure>
            </div>
            {/* Client Block */}
            <div
              className="client-block col-lg-4 col-md-6 col-sm-12 wow fadeInRight"
              data-wow-delay="300ms"
            >
              <figure className="image-box">
                <Link  to="#">
                  <img src="/assets/images/clients/2.jpg" alt="" />
                </Link> 
              </figure>
            </div>
            {/* Client Block */}
            <div
              className="client-block col-lg-4 col-md-6 col-sm-12 wow fadeInRight"
              data-wow-delay="600ms"
            >
              <figure className="image-box">
                <Link  to="#">
                  <img src="/assets/images/clients/3.jpg" alt="" />
                </Link> 
              </figure>
            </div>
            {/* Client Block */}
            <div
              className="client-block col-lg-4 col-md-6 col-sm-12 wow fadeInRight"
              data-wow-delay="900ms"
            >
              <figure className="image-box">
                <Link  to="#">
                  <img src="/assets/images/clients/4.jpg" alt="" />
                </Link> 
              </figure>
            </div>
            {/* Client Block */}
            <div
              className="client-block col-lg-4 col-md-6 col-sm-12 wow fadeInRight"
              data-wow-delay="1200ms"
            >
              <figure className="image-box">
                <Link  to="#">
                  <img src="/assets/images/clients/5.jpg" alt="" />
                </Link> 
              </figure>
            </div>
            {/* Client Block */}
            <div
              className="client-block col-lg-4 col-md-6 col-sm-12 wow fadeInRight"
              data-wow-delay="1500ms"
            >
              <figure className="image-box">
                <Link  to="#">
                  <img src="/assets/images/clients/6.jpg" alt="" />
                </Link> 
              </figure>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

  )
}

export default Client